import './styles/create_event.scss';

import { TextField, Typography } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import "../MembershipRegistration/register.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import Button from "@mui/material/Button";
import BasicDatePicker from "../../components/DatePicker/BasicDatePicker";
import BasicDateTimePicker from "../../components/DatePicker/BasicDateTimePicker";
import FormattedInputs from "../../components/AmountFormatter/FormattedInputs";
import { useForm, Controller } from "react-hook-form";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor";
import FileInput from "../../components/FileInput/FileInput";
import SelectInput from "../../components/TextInput/SelectInput";
import MultipleSelectInput from "../../components/TextInput/MultipleSelectChip.js";
import { styled } from "@mui/material/styles";
import { notification, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import EventController from "./Controller/event_controller.ts";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CustomSeparator from "../../layouts/AdminLayout/Header/Breadcrumbs.js";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import TinyMCE from "../../components/EmailEditor/tinymce-email-builder.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, DateTimePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import DeleteIcon from '@mui/icons-material/Delete';

//i-components
import ToggleSlider from '../../i-components/ToggleSlider.tsx';

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
const CreateEvent = () => {
  const [modal, contextHolderModal] = Modal.useModal();
  const userID = localStorage.getItem("userID");

  const confirm = (message, onConfirm, onCancel) => {
    modal.confirm({
      title: "Confirm",
      icon: <ExclamationCircleOutlined />,
      content: message,
      okText: "Yes",
      cancelText: "Cancel",
      onOk: () => {
        onConfirm();
      },
      onCancel: () => {
        onCancel();
      },
    });
  };

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message) => {
    api[type]({
      message: "Success",
      description: message,
    });
  };

  //parameters declaration
  const key = "12345";
  /* key has no length limit, the longer the length more exhaustive encryption/decryption to process. Key shall not have 0, any 0's will be autoremoved */

  const mode = "YMDHI"; //optional parameter, default will be 'YMDHI'

  //initialize encyptor
  const Encryptor = new InfinityEncryptor(key, mode);

  const required = () => (
    <span style={{ color: "red", marginLeft: "5px", fontSize: "17px" }}>*</span>
  );

  const [selectedColor, setSelectedColor] = useState("#ff0000");
  const [notesContent, setNotesContent] = useState(""); // State to store the edited content

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      userID: userID,
      eventCategory: "",
      eventName: "",
      eventNameHighlightText: "",
      highlight_text_color: "",
      description: "",
      termsAndCondition: "",
      venue: "",
      poster: "",
      document: "",
      earlyBirdRegistrationStartDate: "",
      earlyBirdRegistrationEndDate: "",
      registrationStartDate: "",
      registrationEndDate: "",
      numberOfDays: "1",
      eventStartDateTime: "",
      eventDate: "",
      eventStartTime: "",
      eventEndTime: "",
      paxCount: "",
      minPaxForDiscountRate: "",
      earlyBirdRateMembers: "",
      earlyBirdRateSupportingAssociations: "",
      earlyBirdRateNonMembers: "",
      earlyBirdRateMembersGD: "",
      earlyBirdRateSupportingAssociationsGD: "",
      earlyBirdRateNonMembersGD: "",
      normalRateMembers: "",
      normalRateSupportingAssociations: "",
      normalRateNonMembers: "",
      normalRateMembersGD: "",
      normalRateSupportingAssociationsGD: "",
      normalRateNonMembersGD: "",
      externalRegistrationLink: "",
      CommitteeMembers: "",
      SecretariatMembers: "",
    },
  });

  const selectedValue = watch("eventCategory");
  const selectedNoOfDays = watch("numberOfDays");

  //Clear form when change Event Category
  useEffect(() => {
    reset({
      eventName: "",
      eventNameHighlightText: "",
      highlight_text_color: "",
      description: "",
      termsAndCondition: "",
      venue: "",
      poster: "",
      document: "",
      earlyBirdRegistrationStartDate: "",
      earlyBirdRegistrationEndDate: "",
      registrationStartDate: "",
      registrationEndDate: "",
      numberOfDays: "1",
      eventStartDateTime: "",
      eventDate: "",
      eventStartTime: "",
      eventEndTime: "",
      paxCount: "",
      minPaxForDiscountRate: "",
      earlyBirdRateMembers: "",
      earlyBirdRateSupportingAssociations: "",
      earlyBirdRateNonMembers: "",
      earlyBirdRateMembersGD: "",
      earlyBirdRateSupportingAssociationsGD: "",
      earlyBirdRateNonMembersGD: "",
      normalRateMembers: "",
      normalRateSupportingAssociations: "",
      normalRateNonMembers: "",
      normalRateMembersGD: "",
      normalRateSupportingAssociationsGD: "",
      normalRateNonMembersGD: "",
      externalRegistrationLink: "",
      CommitteeMembers: "",
      SecretariatMembers: "",
    }); // Reset the form
    setClearFileInput((prev) => !prev);
    setClearSelectMultipleInput(true);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input field
    }
  }, [selectedValue]); // Runs when selectedValue changes

  const [clearSelectMultipleInput, setClearSelectMultipleInput] =
    useState(false);

  const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB in bytes

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("userID", userID);
    formData.append(
      "earlyBirdRateMembers",
      Encryptor.Encrypt(data.earlyBirdRateMembers) // Concatenate as string
    );
    formData.append(
      "earlyBirdRateSupportingAssociations",
      Encryptor.Encrypt(data.earlyBirdRateSupportingAssociations)
    );
    formData.append(
      "earlyBirdRateNonMembers",
      Encryptor.Encrypt(data.earlyBirdRateNonMembers)
    );
    formData.append(
      "earlyBirdRateMembersGD",
      Encryptor.Encrypt(data.earlyBirdRateMembersGD)
    );
    formData.append(
      "earlyBirdRateSupportingAssociationsGD",
      Encryptor.Encrypt(data.earlyBirdRateSupportingAssociationsGD)
    );
    formData.append(
      "earlyBirdRateNonMembersGD",
      Encryptor.Encrypt(data.earlyBirdRateNonMembersGD)
    );
    formData.append(
      "normalRateMembers",
      Encryptor.Encrypt(data.normalRateMembers)
    );
    formData.append(
      "normalRateSupportingAssociations",
      Encryptor.Encrypt(data.normalRateSupportingAssociations)
    );
    formData.append(
      "normalRateNonMembers",
      Encryptor.Encrypt(data.normalRateNonMembers)
    );
    formData.append(
      "normalRateMembersGD",
      Encryptor.Encrypt(data.normalRateMembersGD)
    );
    formData.append(
      "normalRateSupportingAssociationsGD",
      Encryptor.Encrypt(data.normalRateSupportingAssociationsGD)
    );
    formData.append(
      "normalRateNonMembersGD",
      Encryptor.Encrypt(data.normalRateNonMembersGD)
    );
    formData.append(
      "externalRegistrationLink",
      Encryptor.Encrypt(data.externalRegistrationLink)
    );
    formData.append("eventCategory", Encryptor.Encrypt(data.eventCategory));
    formData.append("eventName", Encryptor.Encrypt(data.eventName));

    const textValues = HighlightTextandColor.map(item => item.text).join(",");
    const colorValues = HighlightTextandColor.map(item => item.color.replace("#", "")).join(",");
 
    formData.append("highlight_text", Encryptor.Encrypt(textValues));
    formData.append("highlight_text_color", Encryptor.Encrypt(colorValues));

    // console.log("Highlight Text:", textValues);
    // console.log("Highlight Colors:", colorValues);

    formData.append("description", Encryptor.Encrypt(data.description));
    formData.append(
      "termsAndConditions",
      Encryptor.Encrypt(data.termsAndCondition)
    );
    formData.append("venue", Encryptor.Encrypt(data.venue));
    if (data.poster && data.poster.length > 0) {
      formData.append("poster", data.poster[0]);
    }
    if (data.document && data.document.length > 0) {
      formData.append("document", data.document[0]);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input field
    }
    let guest_of_honour_values = [];
    Object.entries(data).forEach(([key, value]) => {
      if (key.startsWith("guestOfHonour_")) {
        guest_of_honour_values.push(value);
      }
    });
    const guest_of_honour_str = guest_of_honour_values.join(",");
    formData.append("guestOfHonours", Encryptor.Encrypt(guest_of_honour_str));
    formData.append(
      "earlyBirdRegistrationStartDate",
      Encryptor.Encrypt(data.earlyBirdRegistrationStartDate)
    );
    formData.append(
      "earlyBirdRegistrationEndDate",
      Encryptor.Encrypt(data.earlyBirdRegistrationEndDate)
    );
    formData.append(
      "registrationStartDate",
      Encryptor.Encrypt(data.registrationStartDate)
    );
    formData.append(
      "registrationEndDate",
      Encryptor.Encrypt(data.registrationEndDate)
    );

    // console.log(data.registrationStartDate)
    // console.log(data.registrationEndDate)

    formData.append("eventDaysCount", Encryptor.Encrypt(selectedNoOfDays));
    formData.append("paxCount", Encryptor.Encrypt(data.paxCount));
    formData.append(
      "minPaxForDiscountRate",
      Encryptor.Encrypt(data.minPaxForDiscountRate)
    );

    const formattedDates = [];

    if (selectedNoOfDays > 0) {
      // Get the first event date as start_date
      const start_date = dayjs(data[`eventDate_1`]).format("YYYY-MM-DD"); 
      // Get the last event date as end_date
      const end_date = dayjs(data[`eventDate_${selectedNoOfDays}`]).format("YYYY-MM-DD"); 

      formData.append("eventStartDate", Encryptor.Encrypt(start_date));
      formData.append("eventEndDate", Encryptor.Encrypt(end_date));
      
      for (let x = 1; x <= Number(selectedNoOfDays); x++) {
        const date = dayjs(data[`eventDate_${x}`]).format("YYYY-MM-DD"); // Format date
        const startTime = dayjs(data[`eventStartTime_${x}`]).format("HH:mm"); // Format start time
        const endTime = dayjs(data[`eventEndTime_${x}`]).format("HH:mm"); // Format end time
      
        formattedDates.push(`${date} ${startTime}-${endTime}`);
      }
      // console.log("Start Date:", start_date);
      // console.log("End Date:", end_date);
      // console.log("Formatted Event Dates:", formattedDates.join(","));
    }
    
    // Join the formatted dates into a single string
    const finalString = formattedDates.join(",");
    // console.log(finalString)

    // Encrypt the final formatted string
    const encryptedData = Encryptor.Encrypt(finalString);

    // Append it to FormData as a single field
    formData.append("eventSchedule", encryptedData);

    // for (let x = 1; x <= Number(selectedNoOfDays); x++) {
    //   formData.append(
    //     `eventStartDateTime_${x}`,
    //     Encryptor.Encrypt(data[`eventStartDateTime_${x}`])
    //   );
    //   formData.append(
    //     `eventDate_${x}`,
    //     Encryptor.Encrypt(data[`eventDate_${x}`])
    //   );
    //   formData.append(
    //     `eventStartTime_${x}`,
    //     Encryptor.Encrypt(data[`eventStartTime_${x}`])
    //   );
    //   formData.append(
    //     `eventEndTime_${x}`,
    //     Encryptor.Encrypt(data[`eventEndTime_${x}`])
    //   );

    //   console.log(data[`eventStartDateTime_${x}`])
    //   // console.log(data[`eventDate_${x}`])
    //   // console.log(data[`eventStartTime_${x}`])
    //   // console.log(data[`eventEndTime_${x}`])
    // }
    formData.append("importantNotes", Encryptor.Encrypt(notesContent));

    formData.append("CommitteeMembers", Encryptor.Encrypt(data.CommitteeMembers));
    formData.append("SecretariatMembers", Encryptor.Encrypt(data.SecretariatMembers));
    const combinedMembers = `${data.CommitteeMembers},${data.SecretariatMembers}`;
    formData.append("AllMembers", Encryptor.Encrypt(combinedMembers));

    //add inAppRegistration
    formData.append('inapp_registration', (inAppRegistration ? '1' : '0'));
    formData.append('members_only', (membersOnly? '1' : '0'));


    console.log(data.CommitteeMembers)
    console.log(data.SecretariatMembers)
    console.log(combinedMembers)

    try {
      if (!(Number(data.eventCategory) === 5)) {
        EventController.createEvent(formData).then((response) => {
          console.log(response);
          if (response.status === "success") {
            const eventID = response.eventID;
            const payload = new FormData();
            payload.append("ID", eventID);
            confirm(
              "Do you want to publish this event? (This will appear in the Super App)",
              () => {
                EventController.publishEventRow(payload).then((response) => {
                  if (response?.status === "success") {
                    openNotificationWithIcon(
                      "success",
                      "Event has been published successfully!"
                    );
                  }
                });
              },
              () => {
                openNotificationWithIcon(
                  "success",
                  "Event has been created successfully!"
                );
              }
            );
            reset();
            setClearFileInput((prev) => !prev);
            setClearSelectMultipleInput(true);

            if (fileInputRef.current) {
              fileInputRef.current.value = ""; // Clear the file input field
            }
          }
        });
      } else if (Number(data.eventCategory) === 5) {
        let meeting_attachments_fields = [];
        Object.entries(data).forEach(([key, value]) => {
          if (key.startsWith("meetingAttachment_")) {
            meeting_attachments_fields.push(value);
          }
        });
        // Append meeting attachments to formData
        meeting_attachments_fields.forEach((file, index) => {
          if (file) {
            formData.append(`meetingAttachments[${index}]`, file[0]);
          }
        });

        let attachment_names_values = [];
        Object.entries(data).forEach(([key, value]) => {
          if (key.startsWith("meetingAttachmentName_")) {
            attachment_names_values.push(value);
          }
        });
        const attachment_names_str = attachment_names_values.join(",");
        formData.append(
          "attachmentNames",
          Encryptor.Encrypt(attachment_names_str)
        );

        EventController.createMeeting(formData).then((response) => {
          console.log(response);
          if (response.status === "success") {
            openNotificationWithIcon(
              "success",
              "Meeting has been created successfully!"
            );
            reset();
            setClearFileInput((prev) => !prev);
            setClearSelectMultipleInput(true);

            if (fileInputRef.current) {
              fileInputRef.current.value = ""; // Clear the file input field
            }
          }
        });
      } 
    } catch (error) {
      console.log("Form submission failed: ", error);
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };
  const fileInputRef = useRef(null); // Create a ref for the file input
  const [clearFileInput, setClearFileInput] = useState(false);

  const handleDataFromFormatterChildComponent = (data, value) => {};

  const [guestOfHonourFields, setGuestOfHonourFields] = useState([]);
  const handleAddguestOfHonour = () => {
    setGuestOfHonourFields([
      ...guestOfHonourFields,
      `guestOfHonour_${guestOfHonourFields.length}`,
    ]);
  };

  const [HighlightTextandColor, setHighlightTextandColor] = useState([]);
  // Add Row
  const handleAddHighlightTextandColor = () => {
    setHighlightTextandColor([
      ...HighlightTextandColor,
      { text: "", color: "#000000" }, // Default empty values
    ]);
  };

  // Remove Row and Clear Data
  const handleRemoveHighlightTextandColor = (index) => {
    setHighlightTextandColor((prev) => prev.filter((_, i) => i !== index));
  };

    // Update Text or Color in Row
    const handleUpdateHighlight = (index, field, value) => {
      setHighlightTextandColor((prev) => {
        const updatedList = [...prev];
        updatedList[index][field] = value;
        return updatedList;
      });
    };

  const [meetingAttachmentFields, setMeetingAttachmentFields] = useState([]);
  const [meetingAttachmentNames, setMeetingAttachmentNames] = useState([]);

  const handleAddAttachment = () => {
    setMeetingAttachmentFields([
      ...meetingAttachmentFields,
      `meetingAttachment_${meetingAttachmentFields.length}`,
    ]);

    setMeetingAttachmentNames([
      ...meetingAttachmentNames,
      `meetingAttachmentName_${meetingAttachmentNames.length}`,
    ]);
  };

  const editorRef = useRef(null);


  //states
  const [inAppRegistration, SetInAppRegistration] = useState(true);
  const [membersOnly, SetMembersOnly] = useState(true);

  //watchers
  //watch for form data update
  useEffect(() => {

  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#e8e8e8",
          height: "100%",
          minHeight: "150vh",
          width: "100vw",
        }}
        className='create_event'
      >
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />

          {contextHolderModal}
          {contextHolder}

          <CustomSeparator pageName="event" />

          <Typography
            gutterBottom
            variant="h4"
            sx={{ color: "text.secondary" }}
          >
            Create Event
          </Typography>

          <form
            onSubmit={handleSubmit(onSubmit, onInvalid, {
              shouldFocusError: true,
            })}
          >
            <Grid container spacing={2}>
              <Grid size={3}>
                <label>Event Category{required()}</label>
              </Grid>
              <Grid size={9}>
                <SelectInput
                  type="text"
                  name="eventCategory"
                  {...register("eventCategory", {
                    required: "This field is required",
                  })}
                  onErrorCheck={
                    errors.eventCategory ? errors.eventCategory.message : ""
                  }
                  control={control}
                />
              </Grid>

              {/* when select meeting category(committee) */}
              {Number(selectedValue) === 5 && (
                <>
                  {/* Meeting Name */}
                  <Grid size={3}>
                    <label>Meeting Name</label>
                  </Grid>
                  <Grid size={9}>
                    <TextInput
                      type="text"
                      {...register("eventName", {
                        required: false,
                      })}
                      onErrorCheck={
                        errors.eventName ? errors.eventName.message : ""
                      }
                      control={control}
                    />
                  </Grid>
                  {/* description */}
                  <Grid size={3}>
                    <label>Description</label>
                  </Grid>
                  <Grid size={9}>
                    <TextInput
                      type="text"
                      {...register("description", {
                        required: false,
                      })}
                      onErrorCheck={
                        errors.description ? errors.description.message : ""
                      }
                      control={control}
                    />
                  </Grid>
                  {/* Venue */}
                  <Grid size={3}>
                    <label>Venue</label>
                  </Grid>
                  <Grid size={9}>
                    <TextInput
                      {...register("venue", {
                        required: "This field is required",
                      })}
                      onErrorCheck={errors.venue ? errors.venue.message : ""}
                      control={control}
                      name="venue"
                    />
                  </Grid>

                  <Grid size={3}>Attachment</Grid>
                  <Grid size={9}>
                    {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> */}
                    <Fab
                      sx={{
                        backgroundColor: "#d33333",
                        "&:hover": { backgroundColor: "#b22222" },
                        color: "#fff",
                      }}
                      aria-label="add"
                      onClick={handleAddAttachment}
                    >
                      <AddIcon />
                    </Fab>
                    {/* </div> */}
                  </Grid>

                  <Grid size={3}>
                    <Typography></Typography>
                  </Grid>
                  <Grid size={9}>
                    {meetingAttachmentFields.map((field, index) => {
                      console.log(meetingAttachmentNames[index]);
                      const fieldAttachmentName = meetingAttachmentNames[index];

                      return (
                        <>
                          <Grid container alignItems="center">
                            {/* File Input */}
                            <Grid item xs={2}>
                              <FileInput
                                key={index}
                                label="Choose"
                                name={field}
                                control={control}
                                rules={{ required: false }}
                                helperText={errors[field]?.message}
                                inputRef={fileInputRef} // Assign the ref to the FileInput component
                                onClearInput={clearFileInput}
                                {...register(field, {
                                  required: false,
                                  validate: (fileList) =>
                                    fileList &&
                                    fileList.length > 0 &&
                                    fileList[0].size > MAX_FILE_SIZE
                                      ? "File size exceeds the 20MB limit."
                                      : true,
                                })}
                              />
                            </Grid>

                            {/* Text Input */}
                            <label key={index}>Rename File</label>

                            <Grid item xs={6} sx={{ width: "50%", ml: "2" }}>
                              <TextInput
                                {...register(fieldAttachmentName, {
                                  required: "This field is required",
                                })}
                                onErrorCheck={
                                  errors[fieldAttachmentName.name]
                                    ? errors[fieldAttachmentName.name].message
                                    : ""
                                }
                                control={control}
                                name={fieldAttachmentName}
                              />
                            </Grid>
                          </Grid>
                        </>
                      );
                    })}
                  </Grid>

                  {/* Dynamically Render Date Pickers */}
                  {/* {Array.from({ length: selectedNoOfDays }, (_, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Grid size={3}>
                          <label>
                            Meeting Start Date and Time Day {index + 1}
                            {required()}
                          </label>
                        </Grid>
                        <Grid size={9}>
                          <BasicDateTimePicker
                            {...register(`eventStartDateTime_${index + 1}`, {
                              required: "This field is required",
                            })}
                            onErrorCheck={
                              errors[`eventStartDateTime_${index + 1}`]
                                ? errors[`eventStartDateTime_${index + 1}`]
                                    .message
                                : ""
                            }
                            control={control}
                          />
                        </Grid>
                      </React.Fragment>
                    );
                  })} */}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {Array.from({ length: selectedNoOfDays }, (_, index) => {
                      return (
                        <React.Fragment key={index}>
                          {/* Event Date */}
                          <Grid size={3}>
                            <label>
                              Meeting Date Time{required()}
                            </label>
                          </Grid>
                          <Grid size={3}>
                            <Controller
                              name={`eventDate_${index + 1}`}
                              control={control}
                              defaultValue={null} // ✅ Ensures the picker is always controlled
                              rules={{ required: "This field is required" }}
                              render={({ field }) => (
                                <DatePicker
                                  label="Select Event Date"
                                  format="DD/MM/YYYY"
                                  value={field.value || null} // ✅ Prevents uncontrolled to controlled error
                                  {...field}
                                  onChange={(date) => field.onChange(date)}
                                  slotProps={{
                                    textField: { 
                                      error: !!errors[`eventDate_${index + 1}`], 
                                      helperText: errors[`eventDate_${index + 1}`]?.message || "" 
                                    }
                                  }}
                                  sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                      fontSize: "16px",
                                      borderRadius: "25px",
                                      color: "black", // Set the input text color to black
                                      backgroundColor: "white", // Set background color to white
                                      "& fieldset": {
                                        borderColor: "#ccc", // Default border color
                                      },
                                      "&:hover fieldset": {
                                        borderColor: "#999", // Border color on hover
                                      },
                                    },
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid size={3}>
                              <Controller
                                name={`eventStartTime_${index + 1}`}
                                control={control}
                                defaultValue={null} // ✅ Ensure initial value is not undefined
                                rules={{ required: "Start time is required" }}
                                render={({ field }) => (
                                  <TimePicker
                                    label="Start Time"
                                    value={field.value || null} // ✅ Ensures controlled behavior
                                    {...field}
                                    onChange={(time) => field.onChange(time)}
                                    slotProps={{
                                      textField: { 
                                        error: !!errors[`eventStartTime_${index + 1}`], 
                                        helperText: errors[`eventStartTime_${index + 1}`]?.message || "" 
                                      }
                                    }}
                                    sx={{
                                      width: "100%",
                                      "& .MuiOutlinedInput-root": {
                                        fontSize: "16px",
                                        borderRadius: "25px",
                                        color: "black", // Set the input text color to black
                                        backgroundColor: "white", // Set background color to white
                                        "& fieldset": {
                                          borderColor: "#ccc", // Default border color
                                        },
                                        "&:hover fieldset": {
                                          borderColor: "#999", // Border color on hover
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                            <Grid size={3}>
                              <Controller
                                name={`eventEndTime_${index + 1}`}
                                control={control}
                                defaultValue={null} // ✅ Ensure initial value is not undefined
                                rules={{ required: "End time is required" }}
                                render={({ field }) => (
                                  <TimePicker
                                    label="End Time"
                                    value={field.value || null} // ✅ Ensures controlled behavior
                                    {...field}
                                    onChange={(time) => field.onChange(time)}
                                    slotProps={{
                                      textField: { 
                                        error: !!errors[`eventStartTime_${index + 1}`], 
                                        helperText: errors[`eventStartTime_${index + 1}`]?.message || "" 
                                      }
                                    }}
                                    sx={{
                                      width: "100%",
                                      "& .MuiOutlinedInput-root": {
                                        fontSize: "16px",
                                        borderRadius: "25px",
                                        color: "black", // Set the input text color to black
                                        backgroundColor: "white", // Set background color to white
                                        "& fieldset": {
                                          borderColor: "#ccc", // Default border color
                                        },
                                        "&:hover fieldset": {
                                          borderColor: "#999", // Border color on hover
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                        </React.Fragment>
                      );
                    })}
                  </LocalizationProvider>

                  <Grid size={3}>
                    <label>Invite Committee Members{required()}</label>
                  </Grid>
                  <Grid size={9}>
                    <MultipleSelectInput
                      type="select"
                      {...register("CommitteeMembers", {
                        required: false,
                      })}
                      onErrorCheck={
                        errors.CommitteeMembers
                          ? errors.CommitteeMembers.message
                          : ""
                      }
                      control={control}
                      clear={clearSelectMultipleInput}
                      setValue={setValue} // Pass setValue to the child component
                    />
                  </Grid>
                  <Grid size={3}>
                    <label>Invite Secretariat Members</label>
                  </Grid>
                  <Grid size={9}>
                  <MultipleSelectInput
                      type="select"
                      {...register("SecretariatMembers", {
                        required: false,
                      })}
                      onErrorCheck={
                        errors.SecretariatMembers
                          ? errors.SecretariatMembers.message
                          : ""
                      }
                      control={control}
                      clear={clearSelectMultipleInput}
                      setValue={setValue} // Pass setValue to the child component
                    />
                  </Grid>
                </>
              )}

              {/* when select others */}
              {!(Number(selectedValue) === 16 || Number(selectedValue) === 5) &&
                selectedValue && (
                  <>
                    {/* Event Name */}
                    <Grid size={3}>
                      <label>Event Name{required()}</label>
                    </Grid>
                    <Grid size={9}>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* highlight text & color */}
                    <Grid size={3}>
                      <label>Event Name Highlight Text and Color</label>
                    </Grid>
                    <Grid size={9}>
                      {HighlightTextandColor.map((item, index) => (
                        <Grid container spacing={2} sx={{marginBottom: '10px'}} alignItems="center" key={index}>
                          {/* Label */}
                          <Grid size={1}>
                            <label>{index + 1}:</label>
                          </Grid>

                          {/* Text Input */}
                          <Grid size={5}>
                          <TextField
                            type="text"
                            value={item.text}
                            onChange={(e) => handleUpdateHighlight(index, "text", e.target.value)}
                            sx={{
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                fontSize: "16px",
                                borderRadius: "25px",
                                color: "black", // Set the input text color to black
                                backgroundColor: "white", // Set background color to white
                                "& fieldset": {
                                  borderColor: "#ccc", // Default border color
                                },
                                "&:hover fieldset": {
                                  borderColor: "#999", // Border color on hover
                                },
                              },
                            }}
                            fullWidth
                          />
                          </Grid>

                          {/* Color Picker */}
                          <Grid size={5}>
                            <TextField
                              name={`highlight_text_color_${index}`}
                              type="color"
                              label="Select Color"
                              variant="outlined"
                              value={item.color} // Default color if undefined
                              onChange={(e) => handleUpdateHighlight(index, "color", e.target.value)}
                              sx={{
                                width: "200px", // Set fixed width
                                "& .MuiOutlinedInput-root": {
                                  fontSize: "16px",
                                  borderRadius: "25px",
                                  color: "black",
                                  backgroundColor: "white",
                                  "& fieldset": { borderColor: "#ccc" },
                                  "&:hover fieldset": { borderColor: "#999" },
                                },
                              }}
                            />
                          </Grid>

                          {/* Remove Button */}
                          <Grid size={1}>
                            <Button
                              onClick={() => handleRemoveHighlightTextandColor(index)}
                              variant="contained"
                              color="error"
                              sx={{ borderRadius: "50px", minWidth: "40px", padding: "5px" }}
                            >
                              <DeleteIcon size={16} />
                            </Button>
                          </Grid> 
                        </Grid>
                      ))}
                    </Grid>
                    <Grid size={3}></Grid>
                    <Grid size={9}>
                      {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> */}
                      <Fab
                        sx={{
                          backgroundColor: "#d33333",
                          "&:hover": { backgroundColor: "#b22222" },
                          color: "#fff",
                        }}
                        aria-label="add"
                        onClick={handleAddHighlightTextandColor}
                      >
                        <AddIcon />
                      </Fab>
                      {/* </div> */}
                    </Grid>
                    {/* Description */}
                    <Grid size={3}>
                      <label>Description{required()}</label>
                    </Grid>
                    <Grid size={9}>
                      <TextInput
                        type="text"
                        {...register("description", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.description ? errors.description.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Terms and Condition */}
                    <Grid size={3}>
                      <label>Terms & Conditions/Cancellation Policy</label>
                    </Grid>
                    <Grid size={9}>
                      <TextInput
                        type="text"
                        {...register("termsAndCondition", {
                          // required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.termsAndCondition ? errors.termsAndCondition.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Venue */}
                    <Grid size={3}>
                      <label>Venue{required()}</label>
                    </Grid>
                    <Grid size={9}>
                      <TextInput
                        {...register("venue", {
                          required: "This field is required",
                        })}
                        onErrorCheck={errors.venue ? errors.venue.message : ""}
                        control={control}
                        name="venue"
                      />
                    </Grid>
                    {/* Attachment */}
                    <Grid size={3}>
                      <Typography>Attachment</Typography>
                    </Grid>
                    <Grid size={9}>
                      <FileInput
                        label="Choose"
                        name="document"
                        control={control}
                        rules={{ required: false }}
                        helperText={errors.document && errors.document.message}
                        inputRef={fileInputRef} // Assign the ref to the FileInput component
                        onClearInput={clearFileInput}
                        {...register("document", {
                          required: false,
                          validate: (fileList) => {
                            if (
                              fileList &&
                              fileList.length > 0 &&
                              fileList[0].size > MAX_FILE_SIZE
                            ) {
                              return "File size exceeds the 20MB limit.";
                            }
                            return true;
                          },
                        })}
                      />
                    </Grid>
                    {/* Poster */}
                    <Grid size={3}>
                      <label>Poster</label>
                    </Grid>
                    <Grid size={9}>
                      <FileInput
                        label="Upload Poster"
                        name="poster"
                        control={control}
                        rules={{ required: false }}
                        helperText={errors.poster && errors.poster.message}
                        inputRef={fileInputRef} // Assign the ref to the FileInput component
                        onClearInput={clearFileInput}
                        {...register("poster", {
                          required: false,
                          validate: (fileList) => {
                            if (
                              fileList &&
                              fileList.length > 0 &&
                              fileList[0].size > MAX_FILE_SIZE
                            ) {
                              return "File size exceeds the 20MB limit.";
                            }
                            return true;
                          },
                        })}
                      />
                    </Grid>
                    {/* Gust of Honour */}
                    <Grid size={3}>
                      <label>Guest of Honour</label>
                    </Grid>
                    <Grid size={9}>
                      {guestOfHonourFields.map((field, index) => (
                        <React.Fragment key={index}>
                          <Grid item="true" xs={4}>
                            <label>{index + 1}: </label>
                          </Grid>
                          <Grid xs={8}>
                            <TextInput
                              {...register(field, {
                                required: false,
                              })}
                              onErrorCheck={
                                errors[field.name]
                                  ? errors[field.name].message
                                  : ""
                              }
                              control={control}
                              name={field}
                            />
                          </Grid>
                        </React.Fragment>
                      ))}
                    </Grid>
                    <Grid size={3}></Grid>
                    <Grid size={9}>
                      {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> */}
                      <Fab
                        sx={{
                          backgroundColor: "#d33333",
                          "&:hover": { backgroundColor: "#b22222" },
                          color: "#fff",
                        }}
                        aria-label="add"
                        onClick={handleAddguestOfHonour}
                      >
                        <AddIcon />
                      </Fab>
                      {/* </div> */}
                    </Grid>
                    {/* Early Bird Registration Start Date */}
                    <Grid size={3}>
                      <label>Early Bird Registration Start Date</label>
                    </Grid>
                    <Grid size={9}>
                      <BasicDatePicker
                        {...register("earlyBirdRegistrationStartDate", {
                          // required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.earlyBirdRegistrationStartDate
                            ? errors.earlyBirdRegistrationStartDate.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Early Bird Registration End Date */}
                    <Grid size={3}>
                      <label>Early Bird Registration End Date</label>
                    </Grid>
                    <Grid size={9}>
                      <BasicDatePicker
                        {...register("earlyBirdRegistrationEndDate", {
                          // required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.earlyBirdRegistrationEndDate
                            ? errors.earlyBirdRegistrationEndDate.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Registration Start Date */}
                    <Grid size={3}>
                      <label>Normal Rate Registration Start Date</label>
                    </Grid>
                    <Grid size={9}>
                      <BasicDatePicker
                        {...register("registrationStartDate", {
                          // required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.registrationStartDate
                            ? errors.registrationStartDate.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Registration End Date */}
                    <Grid size={3}>
                      <label>Normal Rate Registration End Date</label>
                    </Grid>
                    <Grid size={9}>
                      <BasicDatePicker
                        {...register("registrationEndDate", {
                          // required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.registrationEndDate
                            ? errors.registrationEndDate.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Days */}
                    <Grid size={3}>
                      <label>Day(s){required()}</label>
                    </Grid>
                    <Grid size={9}>
                      <Grid size={2}>
                        <TextInput
                          type="number"
                          {...register("numberOfDays", {
                            required: "This field is required",
                          })}
                          onErrorCheck={
                            errors.numberOfDays
                              ? errors.numberOfDays.message
                              : ""
                          }
                          control={control}
                        />
                      </Grid>
                    </Grid>

                    {/* Dynamically Render Date Pickers */}
                    {/* {Array.from({ length: selectedNoOfDays }, (_, index) => {
                      return (
                        <React.Fragment key={index}>
                          <Grid size={3}>
                            <label>
                              Event Start Date & Time Day {index + 1}
                              {required()}
                            </label>
                          </Grid>
                          <Grid size={9}>
                            <BasicDateTimePicker
                              {...register(`eventStartDateTime_${index + 1}`, {
                                required: "This field is required",
                              })}
                              onErrorCheck={
                                errors[`eventStartDateTime_${index + 1}`]
                                  ? errors[`eventStartDateTime_${index + 1}`]
                                      .message
                                  : ""
                              }
                              control={control}
                            />
                          </Grid>
                        </React.Fragment>
                      );
                    })} */}
                    {/* Event Date, Start Time and End Time */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      {Array.from({ length: selectedNoOfDays }, (_, index) => {
                        return (
                          <React.Fragment key={index}>
                            {/* Event Date */}
                            <Grid size={3}>
                              <label>
                                Event Date (Day {index + 1}) {required()}
                              </label>
                            </Grid>
                            <Grid size={3}>
                              <Controller
                                name={`eventDate_${index + 1}`}
                                control={control}
                                defaultValue={null} // ✅ Ensures the picker is always controlled
                                rules={{ required: "This field is required" }}
                                render={({ field }) => (
                                  <DatePicker
                                    label="Select Event Date"
                                    format="DD/MM/YYYY"
                                    value={field.value || null} // ✅ Prevents uncontrolled to controlled error
                                    {...field}
                                    onChange={(date) => field.onChange(date)}
                                    slotProps={{
                                      textField: { 
                                        error: !!errors[`eventDate_${index + 1}`], 
                                        helperText: errors[`eventDate_${index + 1}`]?.message || "" 
                                      }
                                    }}
                                    sx={{
                                      width: "100%",
                                      "& .MuiOutlinedInput-root": {
                                        fontSize: "16px",
                                        borderRadius: "25px",
                                        color: "black", // Set the input text color to black
                                        backgroundColor: "white", // Set background color to white
                                        "& fieldset": {
                                          borderColor: "#ccc", // Default border color
                                        },
                                        "&:hover fieldset": {
                                          borderColor: "#999", // Border color on hover
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                            <Grid size={3}>
                                <Controller
                                  name={`eventStartTime_${index + 1}`}
                                  control={control}
                                  defaultValue={null} // ✅ Ensure initial value is not undefined
                                  rules={{ required: "Start time is required" }}
                                  render={({ field }) => (
                                    <TimePicker
                                      label="Start Time"
                                      value={field.value || null} // ✅ Ensures controlled behavior
                                      {...field}
                                      onChange={(time) => field.onChange(time)}
                                      slotProps={{
                                        textField: { 
                                          error: !!errors[`eventStartTime_${index + 1}`], 
                                          helperText: errors[`eventStartTime_${index + 1}`]?.message || "" 
                                        }
                                      }}
                                      sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                          fontSize: "16px",
                                          borderRadius: "25px",
                                          color: "black", // Set the input text color to black
                                          backgroundColor: "white", // Set background color to white
                                          "& fieldset": {
                                            borderColor: "#ccc", // Default border color
                                          },
                                          "&:hover fieldset": {
                                            borderColor: "#999", // Border color on hover
                                          },
                                        },
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid size={3}>
                                <Controller
                                  name={`eventEndTime_${index + 1}`}
                                  control={control}
                                  defaultValue={null} // ✅ Ensure initial value is not undefined
                                  rules={{ required: "End time is required" }}
                                  render={({ field }) => (
                                    <TimePicker
                                      label="End Time"
                                      value={field.value || null} // ✅ Ensures controlled behavior
                                      {...field}
                                      onChange={(time) => field.onChange(time)}
                                      slotProps={{
                                        textField: { 
                                          error: !!errors[`eventStartTime_${index + 1}`], 
                                          helperText: errors[`eventStartTime_${index + 1}`]?.message || "" 
                                        }
                                      }}
                                      sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                          fontSize: "16px",
                                          borderRadius: "25px",
                                          color: "black", // Set the input text color to black
                                          backgroundColor: "white", // Set background color to white
                                          "& fieldset": {
                                            borderColor: "#ccc", // Default border color
                                          },
                                          "&:hover fieldset": {
                                            borderColor: "#999", // Border color on hover
                                          },
                                        },
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                          </React.Fragment>
                        );
                      })}
                    </LocalizationProvider>
                    {/* Max Pax */}
                    <Grid size={3}>
                      <label>Maximum Pax for Event</label>
                    </Grid>
                    <Grid size={9}>
                      <Grid size={2}>
                        <TextInput
                          type="number"
                          {...register("paxCount", {
                            // required: "This field is required",
                          })}
                          onErrorCheck={
                            errors.paxCount ? errors.paxCount.message : ""
                          }
                          control={control}
                        />
                      </Grid>
                    </Grid>
                    {/* >Minimum Pax for Discount Group */}
                    <Grid size={3}>
                      <label>Minimum Pax for Discount Group</label>
                    </Grid>
                    <Grid size={9}>
                      <Grid size={2}>
                        <TextInput
                          type="number"
                          {...register("minPaxForDiscountRate", {
                            // required: "This field is required",
                          })}
                          onErrorCheck={
                            errors.minPaxForDiscountRate
                              ? errors.minPaxForDiscountRate.message
                              : ""
                          }
                          control={control}
                        />
                      </Grid>
                    </Grid>
                    {/* Important Note */}
                    <Grid size={3}>
                      <label>Important Notes (Appear on Form)</label>
                    </Grid>
                    <Grid size={9}>
                      <Controller
                        name="notesContent"
                        control={control}
                        defaultValue={""}
                        // rules={{ required: "This field is required" }}
                        render={({ field: { onChange, value } }) => (
                          <TinyMCE
                            ref={editorRef}
                            existingContent={""}
                            onContentChange={(content) => {
                              onChange(content); // Ensure react-hook-form gets the updated content
                              setNotesContent(content); // Update local state
                            }}
                          />
                        )}
                      />
                    </Grid>
                    {/* Event Fees */}
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 750 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell align="left">
                              <Box component="div" sx={{ display: "inline" }}>
                                PPK Members
                              </Box>
                            </TableCell>
                            <TableCell align="left">
                              <Box component="div" sx={{ display: "inline" }}>
                                Supporting Associations
                              </Box>
                            </TableCell>
                            <TableCell align="left">
                              <Box component="div" sx={{ display: "inline" }}>
                                Non-members
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {"Early Bird (Single Registration)"}
                            </TableCell>
                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"earlyBirdRateMembers"}
                                  {...register("earlyBirdRateMembers", {
                                    required: false,
                                  })}
                                  onErrorCheck={
                                    errors.earlyBirdRateMembers
                                      ? errors.earlyBirdRateMembers.message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue}
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"earlyBirdRateSupportingAssociations"}
                                  {...register(
                                    "earlyBirdRateSupportingAssociations",
                                    {
                                      required: false,
                                    }
                                  )}
                                  onErrorCheck={
                                    errors.earlyBirdRateSupportingAssociations
                                      ? errors
                                          .earlyBirdRateSupportingAssociations
                                          .message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue} // Pass setValue to the child component
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>

                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"earlyBirdRateNonMembers"}
                                  {...register("earlyBirdRateNonMembers", {
                                    required: false,
                                  })}
                                  onErrorCheck={
                                    errors.earlyBirdRateNonMembers
                                      ? errors.earlyBirdRateNonMembers.message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue} // Pass setValue to the child component
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {"Early Bird (Group Discounted Rate)"}
                            </TableCell>
                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"earlyBirdRateMembersGD"}
                                  {...register("earlyBirdRateMembersGD", {
                                    required: false,
                                  })}
                                  onErrorCheck={
                                    errors.earlyBirdRateMembersGD
                                      ? errors.earlyBirdRateMembersGD.message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue}
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"earlyBirdRateSupportingAssociationsGD"}
                                  {...register(
                                    "earlyBirdRateSupportingAssociationsGD",
                                    {
                                      required: false,
                                    }
                                  )}
                                  onErrorCheck={
                                    errors.earlyBirdRateSupportingAssociationsGD
                                      ? errors
                                          .earlyBirdRateSupportingAssociationsGD
                                          .message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue} // Pass setValue to the child component
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>

                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"earlyBirdRateNonMembersGD"}
                                  {...register("earlyBirdRateNonMembersGD", {
                                    required: false,
                                  })}
                                  onErrorCheck={
                                    errors.earlyBirdRateNonMembersGD
                                      ? errors.earlyBirdRateNonMembersGD.message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue} // Pass setValue to the child component
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {"Normal Rate (Single Registration)"}
                            </TableCell>
                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"normalRateMembers"}
                                  {...register("normalRateMembers", {
                                    required: "This field is required",
                                  })}
                                  onErrorCheck={
                                    errors.normalRateMembers
                                      ? errors.normalRateMembers.message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue}
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"normalRateSupportingAssociations"}
                                  {...register(
                                    "normalRateSupportingAssociations",
                                    {
                                      required: false,
                                    }
                                  )}
                                  onErrorCheck={
                                    errors.normalRateSupportingAssociations
                                      ? errors.normalRateSupportingAssociations
                                          .message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue} // Pass setValue to the child component
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>

                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"normalRateNonMembers"}
                                  {...register("normalRateNonMembers", {
                                    required: false,
                                  })}
                                  onErrorCheck={
                                    errors.normalRateNonMembers
                                      ? errors.normalRateNonMembers.message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue} // Pass setValue to the child component
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {"Normal Rate (Group Discounted Rate)"}
                            </TableCell>
                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"normalRateMembersGD"}
                                  {...register("normalRateMembersGD", {
                                    required: false,
                                  })}
                                  onErrorCheck={
                                    errors.normalRateMembersGD
                                      ? errors.normalRateMembersGD.message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue}
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"normalRateSupportingAssociationsGD"}
                                  {...register(
                                    "normalRateSupportingAssociationsGD",
                                    {
                                      required: false,
                                    }
                                  )}
                                  onErrorCheck={
                                    errors.normalRateSupportingAssociationsGD
                                      ? errors
                                          .normalRateSupportingAssociationsGD
                                          .message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue} // Pass setValue to the child component
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>

                            <TableCell align="right">
                              <Box component="div" sx={{ display: "inline" }}>
                                <FormattedInputs
                                  name={"normalRateNonMembersGD"}
                                  {...register("normalRateNonMembersGD", {
                                    required: false,
                                  })}
                                  onErrorCheck={
                                    errors.normalRateNonMembersGD
                                      ? errors.normalRateNonMembersGD.message
                                      : ""
                                  }
                                  control={control}
                                  clear={clearSelectMultipleInput}
                                  setValue={setValue} // Pass setValue to the child component
                                  onDataPass={
                                    handleDataFromFormatterChildComponent
                                  }
                                />
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/** external registration link */}
                    <Grid size={3}>
                      <label>External Registration Link</label>
                    </Grid>
                    <Grid size={9}>
                      <TextInput
                        type="text"
                        {...register("externalRegistrationLink", {})}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                        _onChange={((value) => { value.trim().length > 0 ? SetInAppRegistration(false) : SetInAppRegistration(true) })}
                      />
                    </Grid>
                    {/** in app registration */}
                    <Grid size={3}>
                      <label>In App Registration</label>
                    </Grid>
                    <Grid size={9}>
                      <ToggleSlider labelA="Off" labelB="On" toggled={inAppRegistration} SetToggled={SetInAppRegistration}/>
                    </Grid>
                    {/** Members Only */}
                    <Grid size={3}>
                      <label>Members Only</label>
                    </Grid>
                    <Grid size={9}>
                      <ToggleSlider labelA="No" labelB="Yes" toggled={membersOnly} SetToggled={SetMembersOnly}/>
                    </Grid>
                  </>
                )}
            </Grid>

            <Box textAlign="center" sx={{ paddingBottom: "80px" }}>
              {/* Add extra bottom padding */}
              <Button
                sx={{
                  borderRadius: "20px",
                  mt: 4,
                  mb: 4,
                  // width: "93.4%",
                  height: "48px",
                  backgroundColor: "#d33333",
                  position: "fixed", // Makes the button fixed
                  bottom: "16px", // Position the button 16px from the bottom
                  transform: "translateX(-50%)", // Aligns the button in the center
                  zIndex: 1000, // Ensures the button stays on top of other elements
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Floating shadow
                  transition: "all 0.3s ease", // Smooth transition for hover effects

                  "&:hover": {
                    backgroundColor: "#b02e2e", // Darker red on hover
                    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)", // Larger shadow on hover
                    transform: "translate(-50%, -5px)", // Moves up slightly on hover
                  },
                }}
                variant="contained"
                type="submit"
              >
                <Typography variant="h6">Save</Typography>
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </>
  );
};

export default CreateEvent;
